module.exports = __webpack_public_path__ + "img/03944455000234.b908c8e3.png";